// import MegaphoneIcon from 'images/svg/megaphone-icon.svg'
// import KeyIcon from 'images/svg/key-icon.svg'
// import PictureIcon from 'images/svg/picture-icon.svg'
// import BulbIcon from 'images/svg/bulb-icon.svg'

import { GoMegaphone } from '@react-icons/all-files/go/GoMegaphone';
import { VscKey } from '@react-icons/all-files/vsc/VscKey';
import { AiOutlinePicture } from '@react-icons/all-files/ai/AiOutlinePicture';
import { AiOutlineBulb } from '@react-icons/all-files/ai/AiOutlineBulb';

export const find_tenants = {
  column_one: [
    {
      title: 'Premium Advertising',
      description:
        'When you sign up, we’ll automatically list your property on Rightmove, Zoopla, OpenRent and more.',
      icon: GoMegaphone,
      footer: '',
      moveUp: false,
    },
  ],
  column_two: [
    {
      title: 'Viewing Management',
      description:
        'We know that booking and attending viewings can be time-consuming. That’s why we will take care of the whole process for you! With our smart AI, we can book and manage more viewings than any other agent on the market.',
      icon: VscKey,
      footer: '',
      moveUp: false,
    },
  ],
  column_three: [
    {
      title: 'Beautiful Photography',
      description:
        'We’ll capture your property’s good side with our professional property photographers. Want to see for yourself? Check out our listings.',
      icon: AiOutlinePicture,
      footer: '',
      moveUp: false,
    },
  ],
  column_four: [
    {
      title: 'Intuitive Staging',
      description:
        'It’s important that you maximise your property’s potential. We can help you layout your property in a way that looks pleasing to the eye. A little feng shui goes a long way!',
      icon: AiOutlineBulb,
      footer: '',
      moveUp: false,
    },
  ],
};
